<template>
  <DialogComponent
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Scheduled Report</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation">Save</el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-checkbox v-model="editForm.enabled"> Enabled </el-checkbox>
      </div>
      <div class="inline-form-group">
        <el-col :span="11">
          <el-input v-model="editForm.name" placeholder="Name">
            <template slot="prefix">Name</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="12">
          <dads-select
            v-model="editForm.frequency"
            placeholder="Select frequency"
          >
            <template slot="prefix">Frequency</template>
            <el-option
              v-for="{ label, value } in frequencyOptions"
              :key="label"
              :label="label"
              :value="value"
            />
          </dads-select>
        </el-col>
      </div>

      <h2 class="form-section-header">Recipients</h2>
      <el-input v-model="editForm.recipients" placeholder="Enter emails">
        <template slot="prefix"> Recipients </template>
      </el-input>

      <div class="inline-form-group">
        <el-col :span="11">
          <el-input disabled v-model="editForm.module" placeholder="Module">
            <template slot="prefix">Module</template>
          </el-input>
        </el-col>
        <el-col :span="1" />
        <el-col :span="12">
          <el-input
            disabled
            v-model="editForm.creatorEmail"
            placeholder="Creator Email"
          >
            <template slot="prefix">Creator Email</template>
          </el-input>
        </el-col>
      </div>

      <scheduled-report-params title="Filters" :params="reportParams" />
    </el-form>
  </DialogComponent>
</template>

<script>
import DialogComponent from "@/components/CustomModalComponent";
import DadsSelect from "@/components/select";
import ScheduledReportParams from "@/components/schedule-reports/ScheduledReportParams";

export default {
  name: "ScheduledReportsEditForm",

  components: {
    DadsSelect,
    ScheduledReportParams,
    DialogComponent,
  },

  props: {
    editVisible: { required: true },
    clearFormFields: { required: true },
    editProcessing: { required: true },
    selectedReport: { required: true },
  },

  data() {
    return {
      frequencyOptions: [
        { label: "Daily", value: "DAILY" },
        { label: "Weekly", value: "WEEKLY" },
        { label: "Monthly", value: "MONTHLY" },
      ],
      recipientOptions: [],
      editForm: {
        tenantId: null,
        name: "",
        module: "",
        frequency: "",
        creatorEmail: "",
        recipients: "",
        parameters: {},
        enabled: false,
      },
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    reportParams() {
      let params = {};
      if (!this.selectedReport || !this.selectedReport.parameters) {
        return params;
      }

      try {
        if (typeof this.selectedReport.parameters === "string") {
          params = JSON.parse(this.selectedReport.parameters);
        } else {
          params = this.selectedReport.parameters;
        }
      } catch (e) {
        //
      }

      return params;
    },
  },

  watch: {
    selectedReport(val) {
      if (val) {
        const {
          tenantId,
          name,
          module,
          frequency,
          creatorEmail,
          recipients,
          enabled,
          parameters,
        } = val;
        this.editForm.tenantId = tenantId;
        this.editForm.name = name;
        this.editForm.module = module;
        this.editForm.frequency = frequency;
        this.editForm.creatorEmail = creatorEmail;
        this.editForm.enabled = enabled === 1;

        this.recipientOptions = [];
        if (recipients && recipients.length) {
          this.recipientOptions = recipients;
          this.editForm.recipients = recipients.join(",");
        }

        this.editForm.parameters = {};
        if (parameters && Object.keys(parameters).length) {
          this.editForm.parameters = parameters;
        }
      }
    },

    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },
  },

  methods: {
    editOperation() {
      let recipients;
      try {
        recipients = this.editForm.recipients.replace(/\s/g, "").split(",");
      } catch (err) {
        return this.$notify({
          type: "error",
          title: "Invalid recipients",
          message: "Recipients must be a valid json.",
        });
      }

      const editBody = {
        tenantId: this.selectedTenant.id,
        name: this.editForm.name,
        frequency: this.editForm.frequency,
        recipients,
        enabled: this.editForm.enabled ? 1 : 0,
      };

      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation");
    },

    clearFields() {
      this.editForm = {
        tenantId: null,
        name: "",
        module: "",
        frequency: "",
        creatorEmail: "",
        recipients: "",
        parameters: "",
        enabled: false,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.el-checkbox {
  margin-left: 0 !important;
}
</style>
